import { useMutation } from '@tanstack/react-query'
import { UpdateAdvertiserParams, updateAdvertiser } from 'supabase/advertisers'
import { queryClient } from 'utils'

export const useUpdateAdvertiser = (
  onSuccess: () => void
) => {
  const mutation = useMutation({
    mutationFn: (advertiser: UpdateAdvertiserParams) => {
      return updateAdvertiser(advertiser)
    },
    onSuccess: (data: any, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['advertisers'],
      })
      queryClient.invalidateQueries({
        queryKey: ['advertiser', `id:${variables.id}`],
      })
      onSuccess()
    },
  })

  return mutation
}